











import BaseComponent from "@/components/BaseComponent.vue";
import { Prop, Component } from "vue-property-decorator";

@Component
export default class WForm extends BaseComponent {
	@Prop({ type: Object, required: true })
	form!: object;

	getComponent(field: any) {
		return "w-field-" + field.field;
	}
}
